export type MessageType = "Banner" | "Outage" | "Ad";
export type MessagePage =
	| "Home"
	| "Support"
	| "MarketingMaterials"
	| "MyOrders"
	| "PlaceNewOrder"
	| "CustomQuotes"
	| "Software"
	| "Everywhere";
export interface MessageBrandSelection {
	brandCode: string;
	allProductLine: boolean;
	productLineKeys: string[];
}
export interface Message {
	messageId: string;
	name: string;
	type: MessageType;
	startUtc: string;
	endUtc: string;
	channels: string[];
	brands: MessageBrandSelection[];
	linkUrl?: string | null;
	imageReference?: string | null;
	text: string;
	page: MessagePage;
	showOnPromotionsPage: boolean;
	erps: string[];
	disablePlacingNewOrders: boolean;
}
export interface TargetingProductLine {
	brandCode: string;
	brandName: string;
	productLineKey: string;
	productLineCode: string;
	productLineName: string;
	originId: number;
}
export interface MessageOptions {
	channels: string[];
	erps: string[];
	pages: MessagePage[];
	productLines: TargetingProductLine[];
	types?: MessageType[];
}
export interface ActiveMessages {
	messages: Message[];
	nextChangeUtc?: string;
	promotions?: Message[];
}
export const pageLabels: Record<MessagePage, string> = {
	Home: "Home Page/Dashboard",
	Support: "Support",
	MarketingMaterials: "Marketing Materials",
	MyOrders: "My Orders",
	PlaceNewOrder: "Place a New Order",
	CustomQuotes: "Custom Quotes",
	Software: "Software",
	Everywhere: "Everywhere"
};
export const canManageMessages = (permissions: readonly string[] = []) =>
	permissions.includes("CONTENT_MANAGER") || permissions.includes("OUTAGE_MANAGER");
export const pageForPath = (path: string): MessagePage => {
	while (path.endsWith("/")) path = path.slice(0, -1);
	if (path === "/dashboard") return "Home";
	if (path === "/support" || path.startsWith("/support/") || path === "/action-items") return "Support";
	if (path === "/software" || path.startsWith("/software/")) return "Software";
	if (path === "/orders" || path === "/projects" || path.startsWith("/details/")) return "MyOrders";
	if (path === "/marketing-materials" || path.startsWith("/marketing-materials/")) return "MarketingMaterials";
	if (
		path === "/new-order" ||
		path.startsWith("/new-order/") ||
		path.startsWith("/add-ons") ||
		path.startsWith("/replacements")
	)
		return "PlaceNewOrder";
	if (path === "/custom-quote" || path.startsWith("/custom-quote/")) return "CustomQuotes";
	return "Everywhere";
};
export const messageError = (error: unknown) => {
	const data = (error as { data?: { errors?: { message?: string }[]; message?: string } })?.data;
	return data?.errors?.[0]?.message ?? data?.message ?? "Unable to save changes. Please try again.";
};
